import { useCallback, useMemo, useRef, useState } from 'react';
import { SlashCommandMenu } from '../DocEditor/components/SlashCommandMenu';
import { excludeSlashIds } from './valueSlash';

/**
 * The same "/" menu as the doc, limited to commands that fit a variable value.
 */
export const useValueSlashMenu = ({ allowedIds, readOnly, onPick, onDismiss }) => {
  const [menu, setMenu] = useState(null);
  const [query, setQuery] = useState('');
  const openRef = useRef(false);
  const allowedKey = allowedIds?.join(',') || '';
  const excludeIds = useMemo(
    () => (allowedKey ? excludeSlashIds(allowedKey.split(',')) : null),
    [allowedKey]
  );

  const close = useCallback(() => {
    openRef.current = false;
    setMenu(null);
    setQuery('');
  }, []);

  const openAt = useCallback(
    (position) => {
      if (readOnly || !allowedKey) return;
      openRef.current = true;
      setQuery('');
      setMenu(position);
    },
    [allowedKey, readOnly]
  );

  const slashMenu =
    menu && allowedKey ? (
      <SlashCommandMenu
        position={menu}
        searchQuery={query}
        excludeIds={excludeIds}
        onSelect={(id) => {
          close();
          onPick?.(id);
        }}
        onClose={() => {
          close();
          onDismiss?.();
        }}
      />
    ) : null;

  return {
    slashMenu,
    slashOpenRef: openRef,
    openAt,
    setQuery,
    close,
  };
};
